import moment from "moment";
import { useCallback, useEffect, useState } from "react";
import DataTable from "react-data-table-component";
import { useTranslation } from "react-i18next";
import DateRangeFilterRTL from "../components/DateRangeFilterRTL";
import { CONSTANTS } from "../constants";
import Layout from "../layouts/layout";
import { getRating, getRatingIcon, toast } from "../utils/utils";
const Feedbacks = () => {
  const { t } = useTranslation();
  const [requests, setRequests] = useState([]);
  const [loading, showLoading] = useState(false);
  const [dateRange, setDateRange] = useState({
    startDate: (new Date().setDate(new Date().getDate() - 30)),
    endDate: new Date(),
  });
  const customStyles = {
    rows: {
      style: {
        minHeight: "72px", // override the row height
      },
    },
    headCells: {
      style: {
        backgroundColor: "#F6F3EE",
        minHeight: "72px",
      },
    },
    cells: {
      style: {
        borderBottom: "1px solid #E9EAEC",
      },
    },
  };
  const conditionalRowStyles = [
    {
      when: () => true,
      style: {
        backgroundColor: "#ffffff",
        "&:nth-of-type(even)": {
          backgroundColor: "#F9F9F",
        },
      },
    },
  ];

  const columns = [
    {
      name: t("Id"),
      sortable: false,
      width: "10%",

      selector: (row) => row.id,
    },
    {
      name: t("Customer"),
      selector: (row) => row.customer,
      width: "25%",
      wrap: true,
    },
    // {
    //   name: t('Contact'),
    //   selector: (row) => row.contactNo,
    //   width:'20%',
    //   wrap: true,
    // },
    {
      name: t("Date"),
      selector: (row) => row.date ? moment(row.date).format("DD-MM-YYYY") : "-",
      width: "10%",
    },
    {
      name: t("Ratings"),
      selector: (row) => (
        <img src={getRatingIcon(row.rating)} height={20} width={20} alt="" />
      ),
      width: "10%",
    },
    {
      name: t("Comments"),
      selector: (row) => row.comments,
      width: "45%",
      wrap: true,
    },
  ];
  const handleDateChange = (range) => {
    setDateRange(range);
    getDataForDashboard(range);
    console.log("Selected Date Range:", range);
  };

  const getDataForDashboard = useCallback((range = null) => {
    showLoading(true);
    const currentRange = range || dateRange;
    const token = window.localStorage.getItem("access_token");
    let url = CONSTANTS.DashboardData;
    if (currentRange.startDate) {
      url =
        url +
        "?from=" +
        moment(currentRange.startDate).format("YYYY/MM/DD") +
        "&to=" +
        moment(currentRange.endDate).format("YYYY/MM/DD");
    }
    fetch(url, {
      headers: {
        Token: `${token}`,
      },
    })
      .then((res) => res.json())
      .then((json) => {
        showLoading(false);
        console.log(json);
        if (json.code === 200) {

          const mapData = json?.data.map((reg, i) => {
            return {
              id: i + 1,
              customer: reg.fullName,
              contactNo: reg.email,
              date: reg.submittedOn,
              rating: getRating(reg.question3),
              comments: reg.question4,
              feedBack: reg.feedBack,
              createdDate: reg.requestedOn,
            };
          });
          setRequests(mapData);
        } else {
          toast(
            "Error",
            json.message || "Failed to fetch the data. Please try again",
            "error"
          );
          if (json?.status === 404) {
            window.localStorage.removeItem("access_token");
            return;
          }
        }
      });
  }, [dateRange]);

  useEffect(() => {
    if (requests.length === 0) {
      getDataForDashboard();
    }
  }, [getDataForDashboard, requests.length]);
  return (
    <>
      <Layout>
        <main
          className={`flex min-h-screen flex-col gap-5 items-center  justify-start `}
        >
          <div className="flex flex-row w-full bg-white  ">
            <div className="flex flex-col flex-1 p-5 gap-5 rounded-lg shadow-md w-full max-w-screen bg-white">
              <div className="flex flex-row text-black justify-between  max-w-screen pt-4 items-start">
                <h1 className="text-black text-2xl font-medium">
                  {t("FeedBacks")}
                </h1>
                <div className=" font-medium text-lg text-neutral-700">
                  <DateRangeFilterRTL onDateChange={handleDateChange} startDateInit={dateRange.startDate} endDateInit={dateRange.endDate} />
                </div>
              </div>
              <div className=" max-w-screen overflow-x-auto  w-full">
                {!loading && (
                  <DataTable
                    columns={columns}
                    data={requests}
                    // onRowClicked={handleRowClick}
                    paginationComponentOptions={{ noRowsPerPage: true }}
                    loading={loading}
                    customStyles={customStyles}
                    highlightOnHover
                    conditionalRowStyles={conditionalRowStyles}
                    pagination
                    pointerOnHover
                  ></DataTable>
                )}
              </div>
            </div>
          </div>
        </main>
      </Layout>
    </>
  );
};

export default Feedbacks;
